import type { Participant, ParticipantEmbeddableForm } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { TbFileDescription } from 'react-icons/tb';
import { ListItem } from '../../components/generic/ListItem';
import { ParticipantEmbeddableFormActionsMenu } from './ParticipantEmbeddableFormActionsMenu';

export const getFormsStyling = (url: string) => {
  if (url.includes('google')) {
    return { color: 'google' };
  }

  if (url.includes('microsoft')) {
    return { color: 'microsoft' };
  }

  return { color: 'tertiary' };
};

interface Props {
  form: ParticipantEmbeddableForm;
  participant: Participant;
}

export const ParticipantEmbeddableFormListItem = (props: Props) => {
  const { form, participant } = props;

  return (
    <ListItem
      icon={
        <ChakraV3.Icon h={10} w={10}>
          <TbFileDescription />
        </ChakraV3.Icon>
      }
      title={form.name}
      secondary={form.url}
      right={<ParticipantEmbeddableFormActionsMenu form={form} participantId={participant.id} />}
      tertiary={null}
    />
  );
};
